import { useEffect } from "react";
import { useOutletContext, Link } from "react-router-dom";
import { TabNames } from "../Assets/variables";
import Images from "../Assets/Images/images";
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import "highcharts/highcharts-more";

const APIOverviewExampleEndOfDayHistory = () => {
    const {setActiveTabItem, apiInfo} = useOutletContext();
    let selectedData = apiInfo.example.data.listings[0];
    let listingsList = apiInfo.example.data.listings;

    useEffect(() => {
        setActiveTabItem(TabNames.Overview);
    }, []);

    function parseMarketData() {
        let eodTimeseries = selectedData.marketData.eodTimeseries;
        let ohlcData = [];
        for (let i = 0; i < eodTimeseries.length; i++) {
            const { sessionDate, open, high, low, close } = eodTimeseries[i];
            const date = new Date(sessionDate).getTime();
            ohlcData.push([date, open, high, low, close]);
        }
        return ohlcData;
    }

    const options = {
        rangeSelector: {
            selected: 2,
            buttons: [{
                type: 'day',
                count: 7,
                text: '1w'
            }, {
                type: 'month',
                count: 1,
                text: '1m'
            }, {
                type: 'month',
                count: 3,
                text: '3m'
            }, {
                type: 'month',
                count: 6,
                text: '6m'
            }, {
                type: 'year',
                count: 1,
                text: '1y'
            }, {
                type: 'year',
                count: 5,
                text: '5y'
            }]
        },
        /* title: {
            text: selectedData.lookup.listingName
        }, */
        chart: {
            height: 600
        },
        credits: {
            enabled: true
        },
        plotOptions: {
            candlestick: {
                color: '#DE3919',
                upColor: '#09A800'
            }
        },
        series: [{
            type: 'candlestick',
            name: selectedData.lookup.listingName,
            data: parseMarketData(),
            tooltip: {
                valueDecimals: 2
            }
        }]
    };
    
    return (
        <>
            <div id="tab-overview" className="api-panel">
                <div className="tab-overview__content">
                    <div className="left-side">
                        <p id="overview-description" dangerouslySetInnerHTML={{ __html: apiInfo.overviewDescription }}></p>
                        <Link
                            id="six-button-trial"
                            className="six-button six-button--action"
                            to={'https://www.six-group.com/en/products-services/financial-information/display-and-delivery-capabilities/six-api/demo.html'}
                            target="_blank">
                            Request a trial
                        </Link>
                    </div>
                    {apiInfo.hasImage &&
                        <div className="right-side">
                            {apiInfo.hasUniquesImage
                                ? <img id="tab-overview__image" src={Images[apiInfo.apiName]} alt={`${apiInfo.apiTitle} overview`} />
                                : <img id="tab-overview__image" src={Images.DefaultAPIImage} alt={`${apiInfo.apiTitle} overview`} />
                            }
                        </div>
                    }
                </div>
                {apiInfo.example &&
                    <>
                        <h4 id="example-title">Example</h4>
                        <div id="eod-chart-example">
                            <div id="eod-chart-example-buttons">
                                { listingsList.map((listing, index) => (
                                    <button key={index} className="eod-chart-example-button eod-chart-example-button--active">
                                        <p className="name">{listing.lookup.listingName}</p>
                                        <p className="type">{listing.lookup.marketName}</p>
                                    </button>
                                )) }
                            </div>
                            <div id="container">
                                <HighchartsReact highcharts={Highcharts} options={options} constructorType={"stockChart"} />
                            </div>
                        </div>
                    </>
                }
            </div>
        </>
    );
};

export default APIOverviewExampleEndOfDayHistory;